import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Partners from "@/pages/Partners";
import IbmSolutions from "@/pages/IbmSolutions";
import KonectSystems from "@/pages/KonectSystems";
import Eeco from "@/pages/Eeco";
import ConsultAudit from "@/pages/ConsultAudit";
import CriticalInfrastructure from "@/pages/CriticalInfrastructure";
import DataCenterAI from "@/pages/DataCenterAI";
import Contact from "@/pages/Contact";
import LegalPage from "@/components/LegalPage";
import CookieConsent from "@/components/CookieConsent";
import { SeoManager } from "@/components/Seo";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-obsidian text-slate-200 flex items-center justify-center p-8">
          <p className="font-mono text-sm">Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const l = window.__lenis;
    if (l) l.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <ScrollManager />
          <SeoManager />
          <div className="bg-obsidian min-h-screen text-slate-100 antialiased selection:bg-sovereign selection:text-obsidian">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/ibm-solutions" element={<IbmSolutions />} />
                <Route path="/konect-systems" element={<KonectSystems />} />
                <Route path="/3eeco" element={<Eeco />} />
                <Route path="/consultanta-audit" element={<ConsultAudit />} />
                <Route path="/critical-infrastructure" element={<CriticalInfrastructure />} />
                <Route path="/datacenter-ai" element={<DataCenterAI />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/termeni" element={<LegalPage docKey="terms" />} />
                <Route path="/gdpr" element={<LegalPage docKey="privacy" />} />
                <Route path="/cookies" element={<LegalPage docKey="cookies" />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
            <CookieConsent />
          </div>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "rgba(13,18,28,0.96)",
                border: "1px solid rgba(0,240,255,0.3)",
                color: "#f8fafc",
              },
            }}
          />
        </ErrorBoundary>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
